'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  content: '[data-el="toggle-content.content"]',
  toggle: '[data-el="toggle-content.toggle"]',
  toggleMessage: '[data-el="toggle-content.toggleMessage"]'
};

var events = exports.events = {
  update: 'toggle-content:update'
};

var ToggleContent = function () {
  /** @param {HTMLElement} el */
  function ToggleContent(el) {
    (0, _classCallCheck3.default)(this, ToggleContent);

    this.el = el;

    this.els = {
      content: this.el.querySelector(selectors.content),
      toggle: this.el.querySelector(selectors.toggle),
      toggleMessage: this.el.querySelector(selectors.toggleMessage)
    };

    this.setupListeners();
  }

  (0, _createClass3.default)(ToggleContent, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.els.toggle.addEventListener('click', function () {
        return _this.toggleContent();
      });
    }
  }, {
    key: 'toggleContent',
    value: function toggleContent() {
      var shouldOpen = !this.isOpen;
      var content = shouldOpen ? this.el.dataset.toggleContentLongDescription : this.el.dataset.toggleContentShortDescription;
      var toggleMessage = shouldOpen ? this.el.dataset.toggleContentTranslationReadLess : this.el.dataset.toggleContentTranslationReadMore;

      this.els.content.innerHTML = content;
      this.els.toggleMessage.textContent = toggleMessage;
      this.el.setAttribute('aria-expanded', shouldOpen);
      this.el.dispatchEvent(new CustomEvent(events.update, { bubbles: true }));
    }
  }, {
    key: 'isOpen',
    get: function get() {
      return this.el.getAttribute('aria-expanded') === 'true';
    }
  }]);
  return ToggleContent;
}();

exports.default = ToggleContent;